/* eslint-disable @typescript-eslint/no-explicit-any */
import { CommonModule } from '@angular/common';
import { Component, DestroyRef, inject, NgZone, OnInit, signal, ViewChild } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CarouselModule } from 'primeng/carousel';
import { InputOtp } from 'primeng/inputotp';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { Subscription } from 'rxjs';
import { FirebaseAuthService } from '../../../services/firebase.auth.service';
import { FirebaseFirestoreService } from '../../../services/firebase.firestore.service';
import { UtilityService } from '../../../services/utility.service';
import { User } from '@angular/fire/auth';
import { Router } from '@angular/router';
import { IftaLabelModule } from 'primeng/iftalabel';
import { InputTextModule } from 'primeng/inputtext';
import { NumericInputModeDirective } from '../../../directives/numeric-input-mode.directive';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-login',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InputTextModule,
    ButtonModule,
    CarouselModule,
    InputOtp,
    InputGroupModule,
    InputGroupAddonModule,
    IftaLabelModule,
    NumericInputModeDirective
  ],
  templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {
  @ViewChild(InputOtp) inputOtp?: InputOtp;

  // Form controls
  phoneNumber = new FormControl('', [Validators.maxLength(10), Validators.minLength(10), Validators.pattern(`^[0-9]*$`)]);
  otp = new FormControl('', [Validators.maxLength(6), Validators.minLength(6), Validators.pattern(`^[0-9]*$`)]);

  // State management
  otpSent = false;
  isLoading = false;
  onOTPValueChangeSubscription?: Subscription;
  errorMessage = '';
  message = '';
  destroyRef = inject(DestroyRef);
  constructor(
    private firebaseAuthService: FirebaseAuthService,
    private firebaseFirestoreService: FirebaseFirestoreService,
    private ngZone: NgZone,
    private utilityService: UtilityService,
    private router: Router
  ) {}

  carouselImages = [
    {
      //url: 'https://firebasestorage.googleapis.com/v0/b/dev-anystoreapp.firebasestorage.app/o/marketing%2Fshopper_we_care.png?alt=media&token=1af04f9f-dd77-4880-942b-a0a21418faf5',
      url: 'https://firebasestorage.googleapis.com/v0/b/dev-anystoreapp.firebasestorage.app/o/marketing%2Fshopper_we_care_2.png?alt=media&token=74ffd4f5-7ad0-47fa-94d3-709b5fe02a97',
      alt: 'We care about you',
      title: 'We care about you',
      description: 'We care about you and we are here to help you'
    },
    {
      //url: 'https://firebasestorage.googleapis.com/v0/b/dev-anystoreapp.firebasestorage.app/o/marketing%2Fshopper_value_time.png?alt=media&token=9c432895-d3f4-471a-965b-753cb2e08e1a',
      url: 'https://firebasestorage.googleapis.com/v0/b/dev-anystoreapp.firebasestorage.app/o/marketing%2Fshopper_value_time2.png?alt=media&token=959074e2-c947-4d45-8c40-02406dd6c6a5',
      alt: 'We value your time',
      title: 'We value your time',
      description: 'We value your time and we are here to help you save it'
    }
  ];

  activeCarouselIndex = 0;

  onCarouselChange(event: any) {
    this.activeCarouselIndex = event.page;
    console.log(this.activeCarouselIndex, event);
  }

  ngOnInit() {
    if (!this.utilityService.deviceInfo) {
      setTimeout(() => {
        this.firebaseAuthService.setRecaptchaVerifier('recaptcha-container');
      }, 500)
    }
  }

  async loginWithPhoneNumber() {
    if(this.utilityService.deviceInfo) {
      console.log('native login')
      this.loginWithNativeFirebase();
      return;
    }

    if(!this.phoneNumber.valid) {
      return;
    }
    try {
      await this.firebaseAuthService.loginWithPhoneNumber('+1' + this.phoneNumber.getRawValue());
      this.otpSent = true;
      this.onOTPValueChange();
    } catch (error) {
      console.log(error)
      this.errorMessage = 'Failed to sent OTP to your phone number. Please try again.';
      this.isLoading = false;
    }
  }

  onOTPValueChange() {
    this.onOTPValueChangeSubscription?.unsubscribe();
    this.onOTPValueChangeSubscription = this.otp.valueChanges.subscribe((value) => {
      if (value?.length === 6) {
        this.clearResendOtpCounterInterval();
        this.verifyOTP();
      }
    });
  }

  async verifyOTP() {
    if(this.utilityService.deviceInfo) {
      this.verifyOTPWithNativeFirebase();
      return;
    }

    this.isLoading = true;
    try {
      const userCredentials = await this.firebaseAuthService.verifyOTP(this.otp.getRawValue() as string);
      this.onOTPVerificationSuccess(userCredentials);
      
    } catch (error) {
      console.error('OTP verification failed:', error);
      this.otp.reset();
      this.startResendOtpCounter();
      this.errorMessage = 'Verification failed. Check your OTP and retry again';
      this.isLoading = false;
      // Handle error - show error message to user
    }
  }

   loginWithNativeFirebase() {
    if(!this.phoneNumber.valid) {
      return;
    }
    (window as any).onLoginConfirmationResult = (error: any) => {
      if(error) {
        this.ngZone.run(() => {
          console.log(error);
          this.errorMessage = 'Unable to login at this time. Sorry for inconvenience, please try again later or reach our support';
          this.isLoading = false;
          this.phoneNumber.reset();
        });
        return;
      }
      this.ngZone.run(() => {
        this.message = 'Please enter below One Time Passcode send to your phone number';
        this.otpSent = true;
        this.onOTPValueChange();
      })
    }

    (window as any).ReactNativeWebView?.postMessage(JSON.stringify({action: "login", data: {phoneNumber: '+1' + this.phoneNumber.getRawValue()}}));
  }

  verifyOTPWithNativeFirebase() {
    this.isLoading = true;

    (window as any).onOTPVerificationSuccess = (data: any) => {
      this.ngZone.run(async() => {
        console.log('onVerifyOTP', data)
        const { uid } = data;
        if(!uid) {
          this.onOTPVerificationFailed();
          return;
        }
        
        try {
          const userCredentials = await this.firebaseAuthService.signInWithToken(uid);
          this.onOTPVerificationSuccess(userCredentials);
        } catch (error) {
          console.log(error);
          this.onOTPVerificationFailed();
        }
      });
    }

    (window as any).ReactNativeWebView?.postMessage(JSON.stringify({action: "verify-otp", data: {otp: this.otp.getRawValue() as string}}));
  }

  async onOTPVerificationSuccess(userCredentials: any) {
    const userProfile = await this.firebaseFirestoreService.getUserDocument(userCredentials?.user as User);
    if (userProfile && !userProfile?.roles.includes('shopper')) {
      // make an api call to update the user profile with the roles
      fetch(`https://updateuserrole-${environment.cloudFunctionProjectId}.a.run.app/?uid=${userProfile.uid}&role=shopper`).then().catch();  
    }
    // Login successful
    console.log('Login successful:', userProfile);
    if (userProfile) {
      this.isLoading = false;
      // Navigate to shopper home or handle successful login
      setTimeout(() => {
        if (!userProfile.onboardingCompleted) {
          console.log('Onboarding not completed, navigating to onboarding');
          this.router.navigate(['/onboarding']);
        } else {
          console.log('Onboarding completed, navigating to home');
          this.router.navigate(['/home']);
        }
      }, 500);
      return;
    }


    // Subscribe to user profile to determine navigation destination
    this.firebaseFirestoreService.subscribeToUserProfile().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((profile) => {  
      if (profile) {
        console.log('User profile loaded:', profile);
        this.isLoading = false;

        if(!profile.roles.includes('shopper')) {
          // make an api call to update the user profile with the roles
          fetch(`https://updateuserrole-${environment.cloudFunctionProjectId}.a.run.app/?uid=${profile.uid}&role=shopper`).then().catch();
        }
        // Navigate based on onboarding status
        if (!profile.onboardingCompleted) {
          console.log('Onboarding not completed, navigating to onboarding');
          this.router.navigate(['/onboarding']);
        } else {
          console.log('Onboarding completed, navigating to home');
          this.router.navigate(['/home']);
        }
      }
    });
  }

   onOTPVerificationFailed() {
    this.otp.reset();
    this.startResendOtpCounter();
    this.errorMessage = 'Verification failed. Check your OTP and retry again';
    this.isLoading = false;
  }

  resendOtpCounter = signal(15);
  resendOtpCounterInterval?: ReturnType<typeof setInterval>;
  startResendOtpCounter() {
    this.resendOtpCounterInterval = setInterval(() => {
      this.resendOtpCounter.set(this.resendOtpCounter() - 1);
      if(this.resendOtpCounter() === 0) {
        this.clearResendOtpCounterInterval();
      }
    }, 1000)
  }

  clearResendOtpCounterInterval() {
    if(this.resendOtpCounterInterval) {
      clearInterval(this.resendOtpCounterInterval);
    }
  }


  ngOnDestroy() {
    this.onOTPValueChangeSubscription?.unsubscribe();
  }
}
